"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flatten;
var _flatten2 = _interopRequireDefault(require("./_flatten.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Flatten out an array, either recursively (by default), or up to `depth`.
// Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
function flatten(array, depth) {
  return (0, _flatten2.default)(array, depth, false);
}